import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=347d013d&scoped=true&"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js&"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=347d013d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d013d",
  null
  
)

export default component.exports